export default __webpack_public_path__ + "static/media/search-solid.bd3a4b32.svg";